
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/es/style.css'

import VxeUITable from 'vxe-table'
import 'vxe-table/es/style.css'

import {ToMoney, ToNumNumber,ToPrice} from "@js/common/utils";

VxeUIAll.VxeUI.formats.add("toMoney", {
    cellFormatMethod: ({cellValue}) => {
        return ToMoney(cellValue)
    }
})
/**
 * 税务专用 金额格式未null的话显示0.0
 */
VxeUIAll.VxeUI.formats.add("toMoneyNew", {
    cellFormatMethod: ({cellValue}) => {
        return ToMoney(cellValue)
    }
})

VxeUIAll.VxeUI.formats.add("toNumNumber", {
    cellFormatMethod: ({cellValue}) => {
        return ToNumNumber(cellValue);
    }
})

VxeUIAll.VxeUI.formats.add("toPrice", {
    cellFormatMethod: ({cellValue}) => {
        return ToPrice(cellValue);
    }
})

VxeUIAll.VxeUI.setConfig({
    size: "mini",
    table: {
        size: 'mini',
        // 4.7+
        scrollX: {
            enabled: true,
            gt: 60
        },
        scrollY: {
            enabled: true,
            gt: 100
        },
        // 4.13+
        virtualXConfig: {
            enabled: true,
            gt: 60
        },
        virtualYConfig: {
            enabled: true,
            gt: 100
        },
        showOverflow: true,
        columnConfig: {
            resizable: true
        },
        cellConfig:{
            height: 40,
        },
        rowConfig: {
            isCurrent: true,
            isHover: true
        }
    },
    button: {
        size: 'medium'
    },
    pager: {
        pageSizes: [10, 15, 20, 50, 100, 200, 500, 1000]
    },
})

export const useTable = (app) => {
    app.use(VxeUIAll)
    app.use(VxeUITable)
}